define('viewModels/widgets/TabbedView',[
    'lib/knockout',
    'lib/lodash4',
    'viewModels/ViewModel',
    'viewModels/SwitchedView'
], function (ko, _, ViewModel, SwitchedView) {
    'use strict';

    var TabHeader = ViewModel.extend(function (tabKey, label, selected, isDisabled) {
        var self = this;

        self.tabKey = tabKey;

        self.label = label;

        self.isDisabled = ko.observable(isDisabled);

        self.isSelected = self.computed(function () {
            return self === selected();
        });
    });

    /**
     * A ViewModel to help with the management of displaying a set of tabs and their
     * respective content.
     *
     * @param {array} tabMenuItems - an array of objects that must adhere to following this structure:
     *
     *    {
     *       tabKey: "string"     // A string representing the unique id of the tab.  This key should also match a viewKey item
     *                            // in the tabViewsMap for the view that should be displayed.
     *
     *       label: "messageKey" // A message key whose value is the text that will
     *                           // display for the nav button
     *
     *       disabled: "boolean"    // Indicates if the tab should be disabled
     *     }
     *
     * @param {map} tabViewsMap  a map of view keys and some metadata to determine which
     *                           ViewModel and template should displayed for a tab.
     *
     *     {
     *       'viewKey': {
     *          view: ViewModelConstructor // A reference to the ViewModel's constructor that should be used for active tab's data
     *          template: "string"         // The path to the template that should be used as the content for the active tab
     *          args: Array                // (optional) Array of arguments to pass to the ViewModel constructor
     *          persist: boolean           // (optional) If specified, only construct this view once; otherwise reconstruct every time the tab is activated
     *       }
     *     }
     */
    return ViewModel.extend(function (tabMenuItems, tabViewsMap) {
        var self = this;
        var subViews = self.subView(SwitchedView);
        var subViewsMap = {};
        self.tabHeaders = ko.observableArray([]);
        self.selectedTabHeader = ko.observable();

        var getCurrentViewData = function () {
            if (self.selectedTabHeader()) {
                var setActiveTabViewArgs = [self.selectedTabHeader().tabKey].concat(self.selectedTabHeader().args);
                var view = subViews.setActiveView.apply(this, setActiveTabViewArgs);

                if (!view) { return null; }

                return {
                    view: view,
                    template: subViewsMap[subViews.getActiveView()].template
                };
            }
            return null;
        };

        self.currentViewData = ko.observable(getCurrentViewData());

        self.multiSubscribe([self.selectedTabHeader, subViews.getActiveView], function() {
            self.currentViewData(getCurrentViewData());
        });

        self.getTabbedView = function(tabKey) {
            if (_.has(subViews, tabKey)) {
                return subViews[tabKey]();
            }
            return null;
        };

        self.addTabViews = function (tabMenuItems, tabViewsMap) {
            _.each(tabMenuItems, function (tabMenuItem) {
                var tabHeader = self.subView(TabHeader, tabMenuItem.tabKey, tabMenuItem.label,
                    self.selectedTabHeader, tabMenuItem.disabled);

                self.tabHeaders.push(tabHeader);
            });

            _.forIn(tabViewsMap, function(value, key) {
                subViewsMap[key] = value;
                var args = [key, value.view].concat(value.args);
                if(value.persist) {
                    subViews.addPersistentView.apply(subViews, args);
                } else {
                    subViews.addView.apply(subViews, args);
                }

                var tabHeader = _.find(self.tabHeaders(), { tabKey: key });
                if (tabHeader) {
                    tabHeader.args = value.args;
                }
            });

            self.selectedTabHeader(self.tabHeaders()[0]);
        };

        self.setActiveTabView = function (tabKey) {
            var tabHeader = _.find(self.tabHeaders(), { tabKey: tabKey });
            if (tabHeader) {
                self.selectedTabHeader(tabHeader);
            }
        };

        self.addTabViews(tabMenuItems, tabViewsMap);
    });
});
